var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "26px",
    viewBox: "0 0 38 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("image", {
    id: "epay",
    x: 0,
    y: 0,
    width: 38,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAaCAYAAADbhS54AAAAAXNSR0IArs4c6QAAASxJREFUSA1jZNj2WZThx58Ohv8MLgwMDHJAPJDgEQPD/x0MbCzVLEBH9QEdFTOQrkGyGxgwjGkMv/5yMzH8/w8KqUEG/jsyAV0oMchcBXQOoyQLkDw4+Bw26qLREKB9CDAyrH/vQHtrSLeBheEfw37StdFeB7AcG5xg1GGkxstoiJEaYqC6Ehk0MjAyHmJg/P8PWZAg+z8jKwPDv1CG/4ypBNUSqYCRYe37/1C1HxiCBQWJ1IepbOsXCYYfv59jSpAngpzG+Bk2fdYmzxigrp9/bMnWi0UjcoiBpP8Cm7YngO2hP1jU4hPiAkqa4lNAqhx6GmMGOsqaVENooR45KmlhPtlmDmqHvSTbWzTT+P85KMT20Mx8sg1mWs/CwMlSCOxb/hxEHd7lDEEC1QDyoz5W1DXYtAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpay);
export default __webpack_public_path__ + "static/media/epay.685030cc30f9a242a136a9f7efabcd21.svg";
export { ForwardRef as ReactComponent };